const state = {
  byName: {}
}

function saveSnapshotToSession(byName) {
  try {
    const serialized = JSON.stringify(byName, (_, value) => {
      if (value instanceof Set) {
        return { __type: 'Set', values: Array.from(value) }
      }
      return value
    })
    sessionStorage.setItem('moduleStates', serialized)
  } catch (e) {
    // Ignore storage errors
  }
}

function revivePersisted(value) {
  if (value && typeof value === 'object') {
    if (value.__type === 'Set' && Array.isArray(value.values)) {
      return new Set(value.values)
    }
    const next = Array.isArray(value) ? [] : {}
    Object.keys(value).forEach((k) => {
      next[k] = revivePersisted(value[k])
    })
    return next
  }
  return value
}

const mutations = {
  SET_MODULE_STATE(state, { moduleName, isEnabled, isLoaded }) {
    state.byName = {
      ...state.byName,
      [moduleName]: {
        ...(state.byName[moduleName] || { data: {} }),
        isEnabled: !!isEnabled,
        isLoaded: !!isLoaded
      }
    }
  },
  SET_MODULE_DATA(state, { moduleName, data }) {
    state.byName = {
      ...state.byName,
      [moduleName]: {
        ...(state.byName[moduleName] || { isEnabled: false, isLoaded: false }),
        data: { ...(state.byName[moduleName]?.data || {}), ...data }
      }
    }
  },
  SET_ALL_MODULE_STATES(state, entries) {
    const next = {}
    entries.forEach(([moduleName, moduleState]) => {
      next[moduleName] = {
        isEnabled: !!moduleState.isEnabled,
        isLoaded: !!moduleState.isLoaded,
        data: { ...(moduleState.data || {}) }
      }
    })
    state.byName = next
  }
}

const actions = {
  initializeFromStorage({ commit }) {
    try {
      const raw = sessionStorage.getItem('moduleStates')
      if (!raw) return
      const snapshot = revivePersisted(JSON.parse(raw))
      const entries = Object.entries(snapshot || {})
      commit('SET_ALL_MODULE_STATES', entries)
    } catch (e) {
      // Ignore parse/storage errors
    }
  },
  setModuleState({ commit, state }, payload) {
    commit('SET_MODULE_STATE', payload)
    saveSnapshotToSession(state.byName)
  },
  setModuleData({ commit, state }, payload) {
    commit('SET_MODULE_DATA', payload)
    saveSnapshotToSession(state.byName)
  },
  setAllModuleStates({ commit, state }, entries) {
    commit('SET_ALL_MODULE_STATES', entries)
    saveSnapshotToSession(state.byName)
  }
}

const getters = {
  moduleStates: state => state.byName,
  getModuleState: state => moduleName => state.byName[moduleName] || { isEnabled: false, isLoaded: false, data: {} }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


